<template>
  <Breadcrumbs
      title="Edit Dispatch"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Dispatch', path: '/dispatch' },
      { label: 'Edit Dispatch', path: '/dispatch-edit' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editDispatch/>
    </div>
  </div>
</template>

<script>
import editDispatch from './distpacheditForm.vue'
export default {
  name: 'indexList',
  components: {
    editDispatch
  },
}
</script>